import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { mergeClasses } from '@utils';

// eslint-disable-next-line import/no-cycle
import { MembershipContext } from './Membership';

export default function MembershipButton({
  as: Component = 'button',
  className = '',
  children,
  ...restProps
}) {
  const { withBackground } = useContext(MembershipContext);

  return (
    <Component
      className={mergeClasses(
        'flex cursor-pointer items-center justify-center rounded-full border border-solid border-[#640CD4] bg-[#640CD4] px-4 py-3 text-sm font-bold text-white',
        {
          'border-0 bg-white/20': withBackground
        },
        className
      )}
      type={Component === 'button' ? 'button' : undefined}
      {...restProps}
    >
      {children}
    </Component>
  );
}

MembershipButton.propTypes = {
  as: PropTypes.oneOf(['button', 'a']),
  className: PropTypes.string,
  children: PropTypes.string.isRequired
};

MembershipButton.defaultProps = {
  as: 'button',
  className: ''
};
